import { Check } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useBooking } from "../context/BookingContext";
import { useSitePath } from "../context/SiteContext";
import { useLocations } from "./SearchPanel";

export const BookingStepper = ({ current }) => {
  const { hotel, rate } = useBooking();
  const navigate = useNavigate();
  const sp = useSitePath();
  const { data: loc } = useLocations();
  const single = loc?.hotels?.length === 1;
  const steps = [
    single ? { n: 1, label: "Search", to: "/", ok: true } : { n: 1, label: "Hotels", to: "/hotels", ok: true },
    { n: 2, label: "Rates", to: hotel ? `/rates/${hotel.id}` : null, ok: !!hotel },
    { n: 3, label: "Services", to: "/services", ok: !!rate },
    { n: 4, label: "Details", to: "/details", ok: !!rate },
  ];
  return (
    <ol className="flex items-center gap-2 overflow-x-auto py-6 sm:gap-4" data-testid="booking-stepper">
      {steps.map((s, i) => {
        const done = s.n < current;
        const active = s.n === current;
        const clickable = s.ok && s.to && !active;
        return (
          <li key={s.n} className="flex flex-1 items-center gap-2 sm:gap-4">
            <button
              type="button"
              disabled={!clickable}
              onClick={() => navigate(sp(s.to))}
              className={`flex items-center gap-3 whitespace-nowrap transition-opacity ${clickable ? "hover:opacity-70" : ""}`}
              data-testid={`step-${s.label.toLowerCase()}`}
            >
              <span className={`grid h-9 w-9 place-items-center rounded-full font-mono text-sm transition-colors ${active ? "bg-brand text-sand" : done ? "bg-gold text-ink" : "border border-ink/15 text-ink/40"}`}>
                {done ? <Check className="h-4 w-4" /> : s.n}
              </span>
              <span className={`text-sm ${active ? "font-medium text-ink" : "text-ink/50"} hidden sm:inline`}>{s.label}</span>
            </button>
            {i < steps.length - 1 && <span className={`h-px flex-1 ${done ? "bg-gold" : "bg-ink/10"}`} />}
          </li>
        );
      })}
    </ol>
  );
};
